<template>
  <section class="accordions">
    <slot />
  </section>
</template>

<script>
import Accordion from '@/components/partials/Accordion.vue'

export default {
  components: {
    Accordion
  }
}
</script>

<style lang="scss">
.accordions {
  margin-top: $accordions-top-margin;
}
</style>

<docs>
  ```vue
    <Accordions>
      <accordion title="Title 1" subtext="This is the subtext" />
      <accordion title="Title 2" subtext="This is the subtext" />
      <accordion title="Title 3" subtext="This is the subtext" />
      <accordion title="Title 3" link="https://lamalama.nl" />
    </Accordions>
  ```
  ```scss
  // Variable defaults:
  $accordions-top-margin: rem(10);
  ```
</docs>
